import "core-js/modules/web.dom-exception.stack.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e8d6a7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  style: {
    "color": "#153578"
  }
}, "登录", -1));
const _hoisted_2 = {
  class: "tip-text"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode(" 您可以致电联合智评客服 "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#153578"
  }
}, "13436936203"), /*#__PURE__*/_createTextVNode(" ，了解试用申请的具体情况 ")], -1));
const _hoisted_4 = {
  class: "dialog-footer"
};
import { ref, watch, reactive } from 'vue';
// import { useRoute, useRouter } from 'vue-router'
import JSEncrypt from 'jsencrypt';
import { downZD, getPublicKey } from '../interface/api';
export default {
  __name: 'loginDialog',
  props: {
    dialogFormVisible: Boolean
  },
  emits: ['closeDialog', 'download'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const tipText = ref(''); // 提示的信息
    const dialogForm = reactive({
      loginName: '',
      password: '',
      osType: null,
      keyId: ''
    });
    const publicKey = ref(''); // 公钥

    //判断系统类型，如果系统为windows，则下载exe文件，如果系统为mac，则下载dmg文件
    // console.log('系统类型',navigator.userAgent,navigator.userAgent.indexOf('Windows'))
    if (navigator.userAgent.indexOf('Windows') !== -1) {
      dialogForm.osType = 1;
      // console.log('系统类型',dialogForm.osType)
    } else if (navigator.userAgent.indexOf('Linux') !== -1) {
      dialogForm.osType = 2;
    } else if (navigator.userAgent.indexOf('Mac') !== -1) {
      dialogForm.osType = 3;
    } else {
      dialogForm.osType = 1;
    }
    let dialogFormVisible = ref(null);
    watch(() => props.dialogFormVisible, () => {
      dialogFormVisible.value = props.dialogFormVisible;
    });
    const closeDialog = () => {
      // console.log('点击叉号');
      emits('closeDialog');
    };

    // let dialogRegiisterVisible = ref(false)
    // const router = useRouter()
    // const route = useRoute()
    let dialogFormVisibleApply = ref(false); // 申请试用dialog
    const goRegister = () => {
      dialogFormVisible.value = false;
      dialogFormVisibleApply.value = true;
      // if(route.path !== '/applyProbation'){
      //     router.push('/applyProbation')
      // } else {
      //     emits('closeDialog')
      // }
    };

    const submitTxt = ref('');
    const getPublicKeyMethod = () => {
      publicKey.value = '';
      dialogForm.keyId = '';
      dialogForm.keyId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      //   console.log('获取公钥111~~~');
      // 返回Promise，以便于可以等待结果
      return new Promise((resolve, reject) => {
        getPublicKey().then(res => {
          // console.log('获取res的是',res);
          if (res && res.data.publicKey) {
            publicKey.value = res.data.publicKey;
            dialogForm.keyId = res.data.keyId;
            resolve(res); // 成功获取公钥，返回结果
          } else {
            // console.error('获取公钥失败，返回数据:', res);
            reject('获取公钥失败'); // 获取失败
          }
        }).catch(error => {
          //   console.error('获取公钥请求出错:', error);
          reject(error); // 请求出错
        });
      });
    };
    //加密
    const encryptMethod = async data => {
      await getPublicKeyMethod();
      // 加密
      const encrypt = (publicKey, data) => {
        try {
          // 确保公钥不为空
          if (!publicKey || typeof publicKey !== 'string') {
            // console.error('公钥为空或格式不正确', publicKey);
            return false;
          }

          // 确保数据是字符串类型
          const stringData = String(data);

          // 创建加密对象
          const encryptor = new JSEncrypt();
          encryptor.setPublicKey(publicKey);

          // 执行加密
          const result = encryptor.encrypt(stringData);
          // console.log('加密原始数据:', stringData);
          // console.log('加密结果:', result);

          return result;
        } catch (error) {
          // console.error('加密过程出错:', error);
          return false;
        }
      };

      // 确保公钥存在，然后进行加密
      if (!publicKey.value) {
        submitTxt.value = '下载';
        // console.error('公钥不存在，无法加密');
        return;
      }

      // 加密登录信息
      const usernameEncrypted = encrypt(publicKey.value, dialogForm.loginName);
      const passwordEncrypted = encrypt(publicKey.value, dialogForm.password);
      // const osTypeEncrypted = encrypt(publicKey.value, dialogForm.osType);

      // 如果任何一个加密失败，则停止登录
      if (!usernameEncrypted || !passwordEncrypted) {
        submitTxt.value = '登录';
        // console.error('加密失败，无法继续登录');
        return;
      }
      const requestData = {
        loginName: btoa(usernameEncrypted),
        password: btoa(passwordEncrypted),
        keyId: dialogForm.keyId,
        osType: dialogForm.osType
      };
      // console.log('requestData', requestData);
      return requestData;
    };
    // watch(() => dialogForm.password,() => {
    //     tipText.value = ''
    // })
    const download = async () => {
      // console.log('点击下载啦',dialogForm);

      // console.log('requestData this.pwdLogin',dialogForm)

      if (dialogForm.loginName && dialogForm.password) {
        let requestData = await encryptMethod(dialogForm);
        // console.log('requestData params',requestData)
        tipText.value = '';
        downZD(requestData).then(res => {
          // console.log('点击立即下载获取数据',dialogForm);
          if (res.data.code == 6221) {
            tipText.value = res.data.msg;
          } else if (res.data.code == 6400) {
            tipText.value = res.data.msg;
          } else if (res.data.code == 2000) {
            // console.log('操作成功',res);
            const a = document.createElement('a');
            const url = res.data.data.exeUrl;
            // a.download = decodeURIComponent(name)
            a.href = url;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            tipText.value = '';
            emits('closeDialog');
            dialogForm.loginName = '';
            dialogForm.password = '';
          } else {
            tipText.value = res.data.msg;
          }
        });
      } else {
        tipText.value = '手机号和密码不能为空';
      }
    };
    const clearTipText = () => {
      tipText.value = '';
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogFormVisible) ? dialogFormVisible.value = $event : dialogFormVisible = $event),
        "close-on-click-modal": false,
        onClose: closeDialog,
        width: "460px",
        top: "30px",
        right: "20px",
        class: "login-dialog",
        style: {
          "border-radius": "10px"
        }
      }, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: dialogForm
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: dialogForm.loginName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogForm.loginName = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "账号/用户名",
              class: "login"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: dialogForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogForm.password = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "请输入密码",
              class: "login",
              type: "password",
              "show-password": "",
              onFocus: clearTipText
            }, null, 8, ["modelValue"])]),
            _: 1
          }), tipText.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(tipText.value), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            class: "system-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: dialogForm.osType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogForm.osType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1,
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [_createTextVNode("Windows 系统")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2,
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [_createTextVNode("Kylin 系统")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 3,
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [_createTextVNode("Mac 系统")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: download,
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(" 立即下载 ")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createElementVNode("p", null, [_createTextVNode("没有账户？"), _createElementVNode("span", {
              class: "register",
              onClick: goRegister
            }, "立即申请")])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisibleApply),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogFormVisibleApply) ? dialogFormVisibleApply.value = $event : dialogFormVisibleApply = $event),
        "close-on-click-modal": false,
        width: "460px",
        top: "16%",
        right: "20px",
        title: "申请试用",
        style: {
          "border-radius": "10px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => _isRef(dialogFormVisibleApply) ? dialogFormVisibleApply.value = false : dialogFormVisibleApply = false),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};